export const environment = {
  production: true,
  stripeKey: 'pk_live_51IeZ65BjrdGenLaH5T1wJgY9RlN7Ub4TjP28hnUL9HSR9Ipi30nwY5tZPRDy1g5NImnyppcvu41l8pgi6uqXc3xh00lAWf4jQG',
  posthog: {
    apiKey: 'phc_dDCKwKQD6KlxlYrmddW0Ru9OhpXvgz5NCUCGUqzKLdN', // Replace with your actual PostHog API key
    apiHost: 'https://t.beadpatternmaker.com', // Or your self-hosted instance URL
  },
};
